import
{
    permissionAllowed,
    SystemShareDisplay
} from '@ews/react-data';
import { useModifySystemShareDisplay, useSystem, useSystemShareDisplay } from '../../../../../../../ReactData/system';
import SettingsCol from '../../../../../../../Settings/SettingsCol/SettingsCol';
import { Props } from './types';

import { useMyPermissions } from '../../../../../../../Login/LoginProvider';
import NumberRange from '../components/NumberRange';

const View: React.FC<Props> = ({ systemId, userId }) =>
{

    const display = useSystemShareDisplay(systemId || "", userId!);
    const myPermissions = useMyPermissions();

    const allowedToEdit = permissionAllowed(myPermissions.createShare || 0);

    const modify = useModifySystemShareDisplay();
    const modifyData = async (data: SystemShareDisplay) => await modify(systemId!, userId!, data);
    const system = useSystem(systemId || "");

    return < SettingsCol
    //size='12' xl='12' md='12' lg='12' sm='12'
    >
        <NumberRange
            disabled={!allowedToEdit}
            label='[SID_MNU_TAB_GROUPS]'
            from={display.fromZone}
            to={display.toZone}
            onChange={(fromZone, toZone) => modifyData({ fromZone, toZone } as SystemShareDisplay)}
        />

        <NumberRange
            disabled={!allowedToEdit}
            label='[SID_MNU_TAB_CONTROLS]'
            from={display.fromActuation}
            to={display.toActuation}
            onChange={(fromActuation, toActuation) => modifyData({ fromActuation, toActuation } as SystemShareDisplay)}
        />

        <NumberRange
            disabled={!allowedToEdit}
            label='[REACT_ALARMINGDEVICE]'
            from={display.fromAlarmingDevice}
            to={display.toAlarmingDevice}
            onChange={(fromAlarmingDevice, toAlarmingDevice) => modifyData({ fromAlarmingDevice, toAlarmingDevice } as SystemShareDisplay)}
        />
        <NumberRange
            disabled={!allowedToEdit}
            label='[REACT_TRANSMISSIONDEVICE]'
            from={display.fromTransmissionDevice}
            to={display.toTransmissionDevice}
            onChange={(fromTransmissionDevice, toTransmissionDevice) => modifyData({ fromTransmissionDevice, toTransmissionDevice } as SystemShareDisplay)}
        />
        {system.hasFloodingZone ? <>

            <NumberRange
                disabled={!allowedToEdit}
                label='COM_FACPMANAGEMENT_SHARE_FIELD_VIEW_FL_FZ_LABEL'
                from={display.fromFloodingZone}
                to={display.toFloodingZone}
                onChange={(fromFloodingZone, toFloodingZone) => modifyData({ fromFloodingZone, toFloodingZone } as SystemShareDisplay)}
            />
        </> : <></>}
    </SettingsCol>;
};
export default View;
